import React, { createContext, useContext, useState } from "react";
import type { ReactNode } from "react";

interface FormErrorContextType {
  formError: string | null;
  setFormError: (message: string | null) => void;
  clearFormError: () => void;
}

const FormErrorContext = createContext<FormErrorContextType | undefined>(undefined);

export const FormErrorProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [formError, setFormError] = useState<string | null>(null);

  const clearFormError = () => setFormError(null);

  return (
    <FormErrorContext.Provider value={{ formError, setFormError, clearFormError }}>
      {children}
    </FormErrorContext.Provider>
  );
};

export const useFormError = (): FormErrorContextType => {
  const context = useContext(FormErrorContext);
  if (!context) throw new Error("useFormError must be used within a FormErrorProvider");
  return context;
};
